import { useState, useEffect } from 'react';
import './index.css';
import Card from '../Cards';
import Footer from '../Footer';
import produtosMemoria from '../../mocks/database.js';
import ProdutoService from '../../services/produtos.service';
// import UsuarioService from '../../services/usuarios.service'

const Home = ({ creatorModal, setCreatorModal, setHunterVisibilitie, hunterVisible }) => {
	const [produtos, setProdutos] = useState([]);
	const getList = async () => {
		setProdutos(produtosMemoria);
		const res = await ProdutoService.getList();
		setProdutos(res);
	};
	useEffect(() => {
		getList();
	}, []);

	return (
		<div className='Home__Container'>
			<Card getList={() => getList()} produtos={produtos} produtosMemoria={produtosMemoria} hunterVisible={hunterVisible} setHunterVisibilitie={setHunterVisibilitie} setCreatorModal={setCreatorModal} creatorModal={creatorModal} />
			<Footer />
		</div>
	);
};

export default Home;
